import React from 'react'
import cx from 'classnames'

import style from './badge.module.css'

const Badge = props => {
    const combinedBadgeClassName = cx(style['badge'], props.className, 't3sel-badge')
    return <span className={combinedBadgeClassName}>{props.children}</span>
}

export { Badge }
